// extracted by mini-css-extract-plugin
export var byline = "blog-post-module--byline--155bf";
export var date = "blog-post-module--date--62da1";
export var meta = "blog-post-module--meta--5f023";